import { useMemo, useState } from "react";

import SearchInput from "../../../ui/inputs/SearchInput";
import LoadingScreen from "../../../ui/loadingScreen/LoadingScreen";
import { formatReceivedAt } from "../../../utils/formatReceivedAt";

import styles from "./LeadWhatsApp.module.css";

export const threadTitle = (thread) => {
  const personName = thread?.person?.name;
  const profileName = thread?.contact_name;
  if (personName && profileName && personName !== profileName) {
    return `${personName} (${profileName})`;
  }
  return personName || profileName || thread?.contact_phone || "Sin contacto";
};

export const threadPreview = (thread) => {
  const last = thread?.last_message;
  if (!last) return "Sin mensajes todavía";
  const prefix = last.direction === "outbound" ? "Vos: " : "";
  return `${prefix}${last.preview || ""}`.trim() || "Sin contenido";
};

const WhatsAppThreadList = ({
  threads = [],
  loading = false,
  error = null,
  selectedThreadId = null,
  onSelect,
  onNewConversation,
}) => {
  const [search, setSearch] = useState("");

  const filteredThreads = useMemo(() => {
    const normalizedSearch = search.trim().toLowerCase();
    if (!normalizedSearch) return threads;
    return threads.filter((thread) =>
      [thread.contact_name, thread.person?.name, thread.contact_phone]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(normalizedSearch)),
    );
  }, [threads, search]);

  return (
    <section className={styles.threadsPanel}>
      <div className={styles.searchContainer}>
        <SearchInput
          value={search}
          onChange={(value) => setSearch(value ?? "")}
          placeholder="Buscar..."
        />
      </div>

      <button
        type="button"
        className={styles.newThreadButton}
        onClick={() => onNewConversation?.()}
      >
        ＋ Nueva conversación
      </button>

      <div className={styles.threadsList}>
        {loading ? (
          <LoadingScreen embedded mainText="Cargando conversaciones..." subText="" />
        ) : error ? (
          <div className={styles.emptyState}>{error}</div>
        ) : filteredThreads.length === 0 ? (
          <div className={styles.emptyState}>
            {threads.length === 0
              ? "Este lead todavía no tiene conversaciones de WhatsApp."
              : "No hay conversaciones para mostrar."}
          </div>
        ) : (
          filteredThreads.map((thread) => {
            const selected = Number(thread.id) === Number(selectedThreadId);
            const unread = Number(thread.unread_count) || 0;
            return (
              <button
                key={thread.id}
                type="button"
                className={`${styles.threadCard} ${selected ? styles.threadCardSelected : ""}`}
                onClick={() => onSelect?.(thread)}
              >
                <div className={styles.threadCardHeader}>
                  <span className={styles.threadTitle}>{threadTitle(thread)}</span>
                  <span className={styles.threadDate}>
                    {formatReceivedAt(thread.last_message_at || thread.created)}
                  </span>
                </div>
                <div className={styles.threadCardBody}>
                  <span className={styles.threadPreview}>{threadPreview(thread)}</span>
                  {unread > 0 && (
                    <span className={styles.unreadBadge} aria-label={`${unread} sin leer`}>
                      {unread}
                    </span>
                  )}
                </div>
              </button>
            );
          })
        )}
      </div>
    </section>
  );
};

export default WhatsAppThreadList;
